export default __webpack_public_path__ + "static/media/widget-placement-child-last.ca32f6a4.svg";